import * as React from 'react';
import { WidgetHelper } from '.';
import { DomComponentProps, Tabs, Accordion } from '../Components';

interface ResponsiveTabsState {
    isMobile: boolean;
}

class ResponsiveTabs extends React.Component<
    DomComponentProps,
    ResponsiveTabsState
> {
    constructor(props: DomComponentProps) {
        super(props);
        this.state = { isMobile: window.innerWidth < 992 };
    }

    onResize = () => {
        this.setState({ isMobile: window.innerWidth < 992 });
    };

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    render() {
        const isMobile = this.state.isMobile;
        const domChildren = this.props.domChildren;
        const domChildSelected = domChildren.find(
            (item) => item.getAttribute('data-active') === 'true'
        );
        return (
            <>
                {isMobile && (
                    <Accordion
                        domChildren={domChildren}
                        domChildSelected={domChildSelected}
                    />
                )}
                {!isMobile && (
                    <Tabs
                        domChildren={domChildren}
                        domChildSelected={domChildSelected}
                    />
                )}
            </>
        );
    }
}

WidgetHelper.register(ResponsiveTabs, 'responsive-tabs');
